import React, { Component } from 'react';
import { TextArea, Form } from 'semantic-ui-react';
import './SummaryEditor.css';

class SummaryEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editedSummary: this.props.originalText || '',
      editedSummaryLength: this.props.originalText ? this.props.originalText.length : 0,
    };
  }

  componentWillUnmount() {
    this.setState({
      editedSummary: '',
      editedSummaryLength: 0,
    });
  }

  changeEditor(evt) {
    this.setState({
      editedSummary: evt.target.value,
      editedSummaryLength: evt.target.value.length,
    });
  }

  render() {
    return (
      <div className='summaryEditor'>
        <h5>{this.props.title}</h5>
        <Form>
          <TextArea
            rows={8}
            onChange={evt => this.changeEditor(evt)}
            value={this.state.editedSummary}
          />
        </Form>
        <p>{this.state.editedSummaryLength}/3000</p>
        <div className='button-block'>
          <button onClick={() => this.props.onCancel()}>Cancel</button>
          <button
            onClick={() => this.props.onSaveAndNext(this.state.editedSummary)}
          >Save & Next
          </button>
          <button onClick={() => this.props.onSave(this.state.editedSummary)}>Save</button>
        </div>
      </div>
    );
  }
}

export default SummaryEditor;



// WEBPACK FOOTER //
// ./src/components/summaryEditor/SummaryEditor.js